export const SMART_METRICS = {
  Header_FLIGHTS_Tab_Clicked: 'Header_FLIGHTS_Tab_Clicked',
  Header_HOTELS_Tab_Clicked: 'Header_HOTELS_Tab_Clicked',
  Header_CARHIRE_Tab_Clicked: 'Header_CARHIRE_Tab_Clicked',
  Header_PACKAGES_Tab_Clicked: 'Header_PACKAGES_Tab_Clicked',
};
